import { UsageTrackerRestServiceV1 } from '@csp/dmdp-api-client';
import type { Maybe, RestOptions } from '@csp/csp-common-model';
import type { UsageTrackerEventTypes } from '../model/UsageTrackerEventTypes';
import type { UsageTrackerTrackEvent } from '../model/UsageTrackerTrackEvent';
import type { UsageTrackerPageEvent } from '../model/UsageTrackerPageEvent';
import type { UsageTrackerIdentifyEvent } from '../model/UsageTrackerIdentifyEvent';
import { UsageTrackerMapper } from '../mapper/UsageTrackerMapper';

const batch = async (
  events: UsageTrackerEventTypes[],
  writeKey: Maybe<string>,
  restOptions: RestOptions,
): Promise<void> => {
  await UsageTrackerRestServiceV1.batch(restOptions, UsageTrackerMapper.toMessageBatchV1(events, writeKey));
};

const page = async (event: UsageTrackerPageEvent, restOptions: RestOptions): Promise<void> => {
  await UsageTrackerRestServiceV1.page(restOptions, UsageTrackerMapper.toMessageV1(event));
};

const track = async (event: UsageTrackerTrackEvent, restOptions: RestOptions): Promise<void> => {
  await UsageTrackerRestServiceV1.track(restOptions, UsageTrackerMapper.toMessageV1(event));
};

const identify = async (event: UsageTrackerIdentifyEvent, restOptions: RestOptions): Promise<void> => {
  await UsageTrackerRestServiceV1.identify(restOptions, UsageTrackerMapper.toMessageV1(event));
};

export const UsageTrackerService = {
  batch,
  page,
  track,
  identify,
};
